import { useTranslation } from "react-i18next";
import { PrimaryButton } from "src/components/Default/LekUI/Button";
import { DefaultReportModal } from "src/components/Modals/ReportsModals/DefaultReportModal";
import { useReportCourseReservation } from "src/hooks/useCourses";
import CircleCheckIcon from "src/images/Icons/newIcons/circleCheck.svg";

interface ReportCourseReservationsModalProps {
	onClose: () => void;
	section: { templateSectionId: string };
}

export function ReportCourseReservationsModal({
	onClose,
	section,
}: ReportCourseReservationsModalProps) {
	const { mutateAsync: report } = useReportCourseReservation() as unknown as {
		mutateAsync: (values: {
			report: string;
			sectionId: string;
		}) => Promise<void>;
	};
	const { t } = useTranslation();
	const onSubmit = async ({ message }: { message: string }) => {
		await report({
			report: message,
			sectionId: section.templateSectionId,
		});
	};

	return (
		<DefaultReportModal
			primaryText={t("modals.reportCourseReservations.submit")}
			onClose={onClose}
			onSubmit={onSubmit}
			title={t("modals.reportCourseReservations.header")}
			subtitle={t("modals.reportCourseReservations.subheader")}
			placeholder={t("modals.reportCourseReservations.stipulation")}
			renderSuccess={() => (
				<div className="w-100 flex flex-col items-center gap-8">
					<CircleCheckIcon className="icon-normal" />
					<h3 className="m-0 size-24">
						{t("modals.reportCourseReservations.successHeader")}
					</h3>
					<p className="size-16-light text-grey m-0">
						{t("modals.reportCourseReservations.successSubheader")}
					</p>
					<PrimaryButton className="mt-24" onClick={onClose}>
						{t("modals.reportCourseReservations.successSubmit")}
					</PrimaryButton>
				</div>
			)}
		/>
	);
}
